import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../../styles/auth/Register.css';
import { GoogleLogin } from '@react-oauth/google';
import { GoogleOAuthProvider } from '@react-oauth/google';

const Register = () => {
    const [email, setEmail] = useState('');
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const response = await fetch('/api/register/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email.trim(),
                    firstname: firstname.trim(),
                    lastname: lastname.trim(),
                }),
            });

            const data = await response.json();
            
            if (response.ok) {
                navigate('/registration-success');
            } else {
                setError(data.error || t('auth.register.registrationFailed'));
            }
        } catch (error) {
            console.error('Registration error:', error);
            setError(t('auth.register.errorOccurred'));
        } finally {
            setIsLoading(false);
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const response = await fetch('/api/register/google/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    token: credentialResponse.credential
                }),
            });

            const data = await response.json();
            
            if (response.ok) {
                navigate('/registration-success');
            } else {
                setError(data.error || t('auth.register.registrationFailed'));
            }
        } catch (error) {
            console.error('Google registration error:', error);
            setError(t('auth.register.errorOccurred'));
        }
    };

    return (
        <div className="loginFormContainer">
            <h2 className="loginFormTitle">{t('auth.register.title')}</h2>
            {error && <div className="errorMessage">{error}</div>}
            <div className="social-login">
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={() => {
                            setError(t('auth.register.googleSignInFailed'));
                        }}
                        theme="outline"
                        size="large"
                        text="signup_with"
                    />
                </GoogleOAuthProvider>
            </div>
            <div className="loginSeperator"></div>
            <form onSubmit={handleSubmit} className="loginForm">
                <div className="loginUsernameForm">
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="loginFormInput"
                        placeholder={t('auth.register.emailPlaceholder')}
                    />
                </div>
                <div className="loginUsernameForm">
                    <input
                        type="text"
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        required
                        className="loginFormInput"
                        placeholder={t('auth.register.firstNamePlaceholder')}
                    />
                </div>
                <div className="loginUsernameForm">
                    <input
                        type="text"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        required
                        className="loginFormInput"
                        placeholder={t('auth.register.lastNamePlaceholder')}
                    />
                </div>
                <button 
                    type="submit" 
                    className="loginFormButton"
                    disabled={isLoading}
                >
                    {isLoading ? t('auth.register.registering') : t('auth.register.registerButton')}
                </button>
            </form>
            <div className="loginSeperator"></div>
            <div className="registerDescription">
                <p>{t('auth.register.alreadyHaveAccount')} <Link to="/login" className="register-link">{t('auth.register.login')}</Link></p>
            </div>
        </div>
    );
};

export default Register;